import * as Config from '../../../config';
import React, {useEffect} from 'react';
import { connect, useSelector } from "react-redux";
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import './Card.css';

import {
  setSelectedItems
} from "../../../actions/index";

import CoverSplit from './CoverSplit';
import Linkage from './Linkage';
import ExplicitTag from '../svg/ExplicitTag';

function ConnectedCard({
    title = null, artists = [], images, style, audio, dragEnabled, playEnabled, beginDrag, endDrag, 
    type, ooWidth, isOnlyCover = false, onClick = () => {},
    isExplicit = false,
    className, children,
    setSelectedItems, storeRoute,
    tag = null
  }) {

  // v11 (rollback) :
  // const [{ opacity }, dragRef, preview] = useDrag({
  //   item: { ...audio, type /*, idParent*/ },
  //   begin: beginDrag || (() => { setSelectedItems([audio])} ),
  //   end: endDrag || ((item, monitor) => { setSelectedItems([]) }),
  //   collect: (monitor) => ({
  //     opacity: monitor.isDragging() ? 0.5 : 1
  //   })
  // })
  const [{ opacity }, dragRef, preview] = useDrag({
    type,
    item: () => {
      (beginDrag || (() => { setSelectedItems([audio]) }))();
      return { ...audio, type /*, idParent*/ };
    },
    end: endDrag || ((item, monitor) => { setSelectedItems([]) }),
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.5 : 1
    })
  })

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview])

  // Double Tap OR Normal Click OR Touch
  const allowAccess = useSelector(state => state.allowAccess);
  const openLink = () => {
    if (audio.uri && allowAccess) {
      storeRoute.goTo(audio.uri);
    }
  }

  return (
    <div id={`refC-${(audio) ? ((audio.ref) ? audio.ref : audio.id) : null}`} ref={(dragEnabled && !Config.TOUCH_ENABLED) ? dragRef : null} className={`CardBP ${className}`} style={{...style, height: (style.height && style.height - 10), opacity, cursor: (dragEnabled) ? `grab` : `pointer`}}>
      {((audio && dragEnabled) || isOnlyCover /*&& playEnabled*/) && (
        <div className={`oo ${isOnlyCover && `only-cover`}`} style={{ width: ooWidth, height: ooWidth }}>
          {(type === `TRACK` || type === `CHART` || type === `CHART-NAV` || type === `RELEASE-NAV` || type === `ARTIST` || type === `LABEL` || type === `RELEASE`) ? <div onClick={openLink} style={{ width: ooWidth, height: ooWidth, opacity: 0 }} /> : null }
        </div>
      )}
      {(type !== `LOAD`) 
        ?  <CoverSplit name={title} images={images} tag={tag} size={isOnlyCover ? ooWidth : style.width} className={isOnlyCover ? `artist-cover` : ``} onlyCover={isOnlyCover} onClick={(type === `TRACK` || type === `CHART` || type === `CHART-NAV` || type === `RELEASE-NAV` || type === `ARTIST` || type === `LABEL` || type === `RELEASE`) ? openLink : null} />
        : <div className={`card-loading`} style={{ width:  style.width, height:  style.width }} />
      }
      { title && <span id={`link-refC-${(audio) ? ((audio.ref) ? audio.ref : audio.id) : null}`} className={`card-title ${type} type-medium ${isExplicit && `ct-explicit`}`} onClick={openLink}>{Config.limitString(title, 30, false)}</span> }
      { (type === 'CHART' || type === 'RELEASE')
        ? <span className={`dj type-small`}>{audio.artists_s}</span>
        : artists.map( (a, i) => <Linkage key={a.id} label={`${(i !== 0) ? `, ` : ``}${a.name}`}
          to={`/artists/${a.slug}/${a.id}`} linkClassName={`link-enable`} /> )
      }
      { isExplicit && <ExplicitTag className={`ET-card`} style={{ top: ooWidth + 3 }} /> }
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

ConnectedCard.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  artists: PropTypes.array,
  images: PropTypes.array.isRequired,
  audio: PropTypes.object,
  style: PropTypes.object,
  onClick: PropTypes.func,
  dragEnabled: PropTypes.bool.isRequired,
  playEnabled: PropTypes.bool.isRequired,
  beginDrag: PropTypes.func,
  endDrag: PropTypes.func,
  isOnlyCover: PropTypes.bool,
  ooWidth: PropTypes.number.isRequired,
  className: PropTypes.string,
}

const Card = connect(
  state => ({
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setSelectedItems: items => dispatch(setSelectedItems(items))
  }) )
(ConnectedCard);

export default Card;
